import { useState } from "react";
export default function useRouterInit() {
    const [state, setState] = useState({
        path: window.location.pathname,
        pathVariables: {},
    });
    return { state, setState };
}
